// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","profileBanner":"_3qZ-o_BgxkYDSrCGzEjXGN","profileSection":"_1Xxv2wXtYYzDm1B9kE3dw7"};